import React, { useState } from 'react';
import { CountryDropdown } from 'react-country-region-selector';

import { useCookies } from 'react-cookie';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { Link } from 'gatsby';
import { submitForm } from '../utils/api';

import uncheckedButton from '../assets/images/unchecked-radio-button.svg';
import checkedButton from '../assets/images/checked-radio-button.svg';
import checkCircle from '../assets/images/green-check-circle.svg';
import success from '../assets/images/success-message.svg';
import { countries, prefferedCountries } from '../utils/countries';

const SteeringForm = ({ initialPartnership = '' }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [country, setCountry] = useState('');
  const [partnership, setPartnership] = useState(initialPartnership);
  const [notification, setNotification] = useState(null);

  const [cookies] = useCookies(['hubspotutk']);
  const hutk = cookies.hubspotutk;

  const portalId = '7694073';
  const formId = 'f478d066-8cfb-467d-9953-bade088d3d7c';

  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return (
    <>
      <div className={`form ${notification ? '-hidden' : ''}`}>
        <h1>Join us in shaping the future of Fibonacci</h1>
        <div className="form-group">
          <div className="label">Type of partnership</div>
          <div className="radio">
            <button
              className={`choice ${partnership === 'Steering Group' ? '-active' : ''}`}
              onClick={() => setPartnership('Steering Group')}
            >
              <img
                className={`checked ${partnership === 'Steering Group' ? '' : '-hidden'}`}

                src={checkedButton}
                alt="checked"
              />
              <img
                className={`unchecked ${partnership === 'Steering Group' ? '-hidden' : ''}`}

                src={uncheckedButton}
                alt="unchecked"
              />
              <span className="label">Steering Group</span>
            </button>
            <button
              className={`choice ${partnership === 'Implementation Partners' ? '-active' : ''}`}
              onClick={() => setPartnership('Implementation Partners')}
            >
              <img
                className={`checked ${partnership === 'Implementation Partners' ? '' : '-hidden'}`}

                src={checkedButton}
                alt="checked"
              />
              <img
                className={`unchecked ${partnership === 'Implementation Partners' ? '-hidden' : ''}`}
                src={uncheckedButton}
                alt="unchecked"
              />
              <span className="label">Implementation Partners</span>
            </button>
          </div>
        </div>
        <div className="form-group">
          <div className="label">Full name</div>
          <input
            className="input"
            onChange={(e) => {
              setName(e.target.value);
            }}
            value={name}
          />
        </div>
        <div className="form-group">
          <div className="label">Work email</div>
          <input
            className="input"
            placeholder="name@company.com"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            value={email}
          />
        </div>
        <div className="form-group">
          <div className="label">Role title</div>
          <input
            className="input"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            value={title}
          />
        </div>
        <div className="form-group">
          <div className="label">Country</div>
          <select onChange={e => setCountry(e.target.value)} className="select">
            <optgroup>
              <option>Select country</option>
              </optgroup>
            <optgroup>
              {prefferedCountries.map((p, i) => (
                <option key={i}>{p}</option>
              ))}
            </optgroup>
            <optgroup>
              {countries.map((c, i) => (
                <option key={i}>{c}</option>
              ))}
            </optgroup>
          </select>
        </div>
        <div className="grecaptcha-attribution mb-24">
          This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </div>
        <button
          style={{ marginTop: 24 }}
          className="base-button -primary -large"
          onClick={async () => {
            if (re.test(String(email).toLowerCase())) {
              const token = await executeRecaptcha('steeringGroupForm')
              const params = {
                email: email,
                full_name: name,
                jobtitle: title,
                country: country,
                partnership_type: partnership,
                token: token
              }

              submitForm(params)
                .then((res) => {
                  if (res.ok) {
                    setNotification(true);
                  } else {
                    setNotification(false);
                  }
                });
            } else {
              setNotification(false);
            }
          }}
        >
          Get in touch
        </button>
        <div
          className={`form-response ${notification != null ? '-visible' : ''}`}
          style={{
            display: notification == null ? 'none' : 'flex', margin: '0 auto', fontSize: '14px', marginTop: 8,
          }}
        >
          {notification && (<img src={checkCircle} className="_mr-8" alt="check icon" />)}
          <div className="message" style={{ color: notification ? '#1E262B' : '#CC4643' }}>
            {notification
              ? 'Thanks for your interest in joining the movers and shakers of #legaltech. We\'ll be in touch soon to confirm next steps.'
              : 'Your email doesn\'t look right!'}
          </div>
        </div>
      </div>
      <div className={`success ${notification ? '-show' : ''}`}>
        <div className="title">
          Thank you for your interest in Fibonacci
        </div>
        <div className="subtitle">
          Our team will be in touch soon.
        </div>
        <img
          className="image"
          src={success}
          alt="success"
        />
        <div className="actions">
          <Link className="base-button -large" to="/">
            <div>Go back to homepage</div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default SteeringForm;
